import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';
import { UserISAStatus } from 'types';

export const driveUserISAStatusOptions = [
	{ value: UserISAStatus.ABOVE_ISA, label: 'Above ISA' },
	{ value: UserISAStatus.BELOW_ISA, label: 'Below ISA' },
	{ value: UserISAStatus.MORAT, label: 'Morat' },
	{ value: UserISAStatus.NO_REVENUE, label: 'No Revenue' },
	{ value: UserISAStatus.ONLY_INTERN, label: 'Only Intern' },
];

const DriveUserISAStatusFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const isaStatus = JSON.parse(searchParams.get('isaStatus') || '[]');
	const options = driveUserISAStatusOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!isaStatus?.length}
					placeholder={'ISA Status'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: isaStatus?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (isaStatus?.includes(option?.value?.toString())) {
											searchParams.set(
												'isaStatus',
												JSON.stringify(isaStatus?.filter((status: string) => status !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('isaStatus', JSON.stringify([...isaStatus, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{isaStatus?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">ISA Status</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="ISA Status"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => isaStatus?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('isaStatus', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default DriveUserISAStatusFilterInput;
